
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how_we_4ward",
      function () {
        return require("private-next-pages/how_we_4ward.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how_we_4ward"])
      });
    }
  